import Polygon from '../../canvas/polygon'
import PolygonCreator, { Area } from '../polygon'

class PolygonTouchCreator extends PolygonCreator {
  onMouseDown(area: Area) {
    this.mouseDowns++
    const first = this.attrs.points[0]
    const margin = {
      x: this.model.scale.x.invert(15),
      y: this.model.scale.y.invert(0) - this.model.scale.y.invert(15),
    }
    if (this.mouseDowns !== 1 && this.isSamePoint({ pointA: first, pointB: area, margin })) {
      this.attrs.points.shift()
      this.attrs.points.push({
        x: first.x,
        y: first.y,
      })
      this.release()
      this.replaceMyself(Polygon.fromObject<Polygon>(this.attrs, this.model))
      this.toolsCallback()
    } else if (this.mouseDowns !== 1 && this.isSamePoint({ pointA: this.lastMouseDown, pointB: area, margin })) {
      this.attrs.points.shift()
      this.release()
      this.replaceMyself(Polygon.fromObject<Polygon>(this.attrs, this.model))
      this.toolsCallback()
    } else {
      this.attrs.points[this.mouseDowns] = { x: area.x, y: area.y }
    }
    this.lastMouseDown = { x: area.x, y: area.y }

    this.trigger('change')
  }
}

export default PolygonTouchCreator
